import React, { useEffect, useState, useRef } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useSelectionStore } from '@/store/selectionStore';
import { useGetUserProfile } from '@/api/auth/useAuth';
import { usePolicyStore } from '@/policy/policyStore';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { login, logout, setLoading, user: storedUser } = useAuthStore();
  const [hasToken, setHasToken] = useState(false);
  const { setPolicyFromUser, reset } = usePolicyStore();
  const { reset: resetSelection } = useSelectionStore();
  const initialCheckDone = useRef(false);

  // 마운트 시 1회만 토큰 확인 (storedUser 변경에 의한 재실행 방지)
  useEffect(() => {
    if (initialCheckDone.current) return;
    initialCheckDone.current = true;

    const token = sessionStorage.getItem('access_token');
    const tokenExpiry = sessionStorage.getItem('token_expiry');

    if (token && (!tokenExpiry || new Date() <= new Date(tokenExpiry))) {
      setHasToken(true);
      setPolicyFromUser(storedUser);
    } else {
      logout();
      resetSelection();
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      sessionStorage.removeItem('token_expiry');
      reset();
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: user, isLoading, isError } = useGetUserProfile({ enabled: hasToken });

  useEffect(() => {
    if (!isLoading && hasToken) {
      if (isError) {
        logout();
        resetSelection();
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('token_expiry');
        reset();
        setLoading(false);
      } else if (user) {
        login(user);
        setPolicyFromUser(user);
        setLoading(false);
      }
    }
  }, [user, isLoading, isError, hasToken, login, logout, reset, resetSelection, setLoading, setPolicyFromUser]);

  return <>{children}</>;
};
